/**
 * Scales a Lucide-convention strokeWidth (designed for a 24-unit viewBox) to an
 * arbitrary target viewBox size. When `absoluteStrokeWidth` is true, also corrects
 * for the rendered icon size so the stroke appears the same physical thickness
 * regardless of how large the icon is rendered — matching Lucide's own behaviour.
 */
export function resolveStrokeWidth(
  strokeWidth: number | string,
  size: number | string,
  options?: { absolute?: boolean; viewBoxSize?: number }
): number {
  const sw = Number(strokeWidth)
  const sz = Number(size)
  const scaled = sw * ((options?.viewBoxSize ?? 256) / 24)
  return options?.absolute ? scaled * (24 / sz) : scaled
}
